import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'eventq-talkdown-group',
  templateUrl: './talkdown-group.html',
  styleUrl: './talkdown-group.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqTalkdownGroup {
  readonly speakerName = input.required<string>();
  readonly cameraLabels = input.required<string[]>();

  readonly activate = output<void>();
}
